import React,{ useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Notice from "../../partials/content/Notice";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";
 import {  format } from 'date-fns';
import CodeExample from "../../partials/content/CodeExample";
import { getUserByToken,signedUrlBanner,s3Upload,getFile,getBannersByAccount,updateMaster } from "../../crud/auth.crud";
import FileUploadPreview from './FileUploadPreview';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import ReactS3Uploader from "react-s3-uploader"
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import Radio from '@material-ui/core/Radio';

import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';



const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
};





class EditBanner extends React.Component {
  state = {
    fields:[],
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    selDate:new Date('2014-08-18T21:11:54'),
    showImage:false,
    showText:false,
    entities:1,
    banner: {},
    statusMap:{},
  }



  handleDateChange = (date: Date | null) => {
    this.setState({selDate:date});
  };

  handleZipChange = (e) => {

    const {setFieldValue} = this.props;
    console.log(e.target.name);
    console.log(e.target.value);

    setFieldValue("country", "USA");
    setFieldValue("state", "MA");
    setFieldValue("city", "Boston");
  };

getSignedUrl = (file, callback) =>
  {
    //this.setState({open:true});
    console.log("getSignedUrl");
    const params = {
    objectName: file.name,
    contentType: file.type
  };
    console.log(params);
    signedUrlBanner({ params })
    .then(data => {
      //callback(data.data);
      //console.log(data.data);
     // s3Upload(data.data.signedUrl,file,{headers:{'x-amz-acl': 'public-read','Content-Type' : params.contentType}})
      s3Upload(data.data.signedUrl,file)
      .then(response => response.data)
        .then((data) => {
         
            console.log(data);
         });
    })
    .catch(error => {
      //console.log(error);
    });

}

 getUploadParams = async  ({ file, meta: { name } }) => {

  //console.log(this.state.patient.id);
  //let id = this.state.patient.id;
  let id=this.state.user[0].accountKey;
  let path = "banner";
  let url ="";
     await signedUrlBanner({ path,name,id })
    .then(data => {
      url = data.data.signedUrl;
      
    })
    //console.log("url 2===="+url);
    //console.log("url===="+ url);
    console.log(file);
    return { body: file, meta: {}, url:  url,method:'PUT'}
  }

   handleSubmit = (files, allFiles) => {
    //console.log(files.map(f => f.meta))
    //allFiles.forEach(f => f.remove())
    //console.log('here');
    //files.map((f) => (
        //console.log(f.meta)
      //))
  }

  handleChangeStatus = ({ meta }, status) => {
    //console.log(status, meta)
    //let id = this.state.patient.id;
    const fileId = meta.id;

    console.log("meta::::::",meta);
    let id=this.state.user[0].accountKey;
    if(status=="done")
    {
      this.setState({imagePath: 'banner/'+id+'/'+meta.name})
     /* addFile(id,meta.name,meta.size,meta.type).then(response => response.data)
        .then((data) => {
            getPatientById(id).then(response => response.data)
          .then((data) => {
            this.setState({ patients: data })
            //console.log(data);
           });
        });*/
        this.setState({
					statusMap: {
						...this.state.statusMap,
						[fileId]: "verified"
					}
					});
    }
  }



constructor(props)
{
  let bannerProps={};
  let showText = false;
  let showImage =false;
  if(props.location.data!=null && props.location.data.banner!=null && props.location.data.banner!=undefined)
  {
    bannerProps = props.location.data.banner;
    if(bannerProps.bannerType==="image")
    {
      showImage = true;
      showText = false;
    }
    else
    {
      showImage = false;
      showText = true;
    }
    console.log("bbaner:::",bannerProps);
  }
  super(props);
    this.state = {
      menu: false,
      fields:[],
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      locading:false,
      statusColor:'alert-success',
      accounts:[],
      showText:showText,
      showImage:showImage,
      //expiryDate:format(new Date(bannerProps.expiryDate),"yyyy-MM-ddThh:mm.sssZ"),
      //publishDate:format(new Date(bannerProps.publishDate),"yyyy-MM-ddThh:mm.sssZ"),
      expiryDate:new Date(bannerProps.expiryDate),
      publishDate:new Date(bannerProps.publishDate),
      displayOrder: bannerProps.displayOrder,
      imagePath: bannerProps.imagePath,
      bannerType: bannerProps.bannerType,
      entities:1,
      banner: bannerProps,
      statusMap:{},
    };


    
  this.toggleMenu = this.toggleMenu.bind(this);
  //this.handleClick = this.handleClick.bind(this);
}
  
  
  toggleMenu(){
    this.setState({ menu: !this.state.menu })
  }

  componentDidMount()
  {
    
    getUserByToken().then(response => response.data)
    .then((data) => {
      this.setState({ user: data })
      console.log(data);
     });

    getBannersByAccount().then(response => response.data)
    .then((data) => {
      console.log("length:::::",data.filter(b=> b.isActive===true).length);
      this.setState({ entities: parseInt(data.filter(b=> b.isActive===true).length)+1 })
      //console.log(this.state.users)
     })

    
     
  }

handleRadioChange=(e)=>
{
    console.log(e.currentTarget.value);
    let value = e.currentTarget.value;
    if(value=="text")
    {
      this.setState({showImage:false,showText:true,bannerType:value});

    }
    else
    {
       this.setState({showImage:true,showText:false,bannerType:value});
    }
}
  
handleClickDetails(user)
  {
    return function(){
      console.log('handleClickDetails');
           
    }

    
  
} 



  render() {
    
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;
     const showImage = this.state.showImage? "block" : "none";
     const showText = this.state.showText ? "block" : "none" ;

    return (
      <>

          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}

           <Formik
                  initialValues={{
                    bannerMessage:this.state.banner.message,
                    displayOrder:this.state.banner.displayOrder,
                    displayTime: this.state.banner.displayTime,
                    publishTo: this.state.banner.publishTo
                    
                  }}
                  validate={values => {
                    const errors = {};

 
                  {/* if (!values.dateOfBirth) {
                      errors.dateOfBirth = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }*/}

                     if (!values.publishTo) {
                      errors.publishTo = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.displayTime) {
                      errors.displayTime = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!this.state.bannerType) {
                      errors.bannerType = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!this.state.publishDate) {
                      errors.publishDate = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!this.state.expiryDate) {
                      errors.expiryDate = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                   

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {
                    this.setState({loading:true});
                   
                      let data  = {
                      'bannerKey': this.state.banner.bannerKey,
                      'bannerId': this.state.banner.bannerId,
                      'bannerType' : this.state.bannerType,
                      'imagePath': this.state.imagePath,
                      'message' : values.bannerMessage,
                      'publishTo' : values.publishTo,
                      'publishDate' : this.state.publishDate,
                      'expiryDate' : this.state.expiryDate,
                      'accountKey' : this.state.user[0].accountKey,
                      'displayTime' : values.displayTime,
                      'displayOrder': values.displayOrder
                    }


                    updateMaster('banner',this.state.banner.id,data)
                      .then(resp => {
                        //props.register(accessToken);
                       
                        this.setState({status:true,
                        statusMessage:'Banner updated successfully',
                        alertType:'alert-success',loading:false});
                         window.scrollTo(0,0);
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      
        	
      		<CodeExample beforeCodeTitle="Banner Details">
        	<div className="kt-section">
	        	<div className="kt-section__content">
           

		   			
		   			<div className="row">
		   			          
                      <div className="col-12">
                          <FormControl component="fieldset">
                            <FormLabel component="legend">Banner Type</FormLabel>
                            <RadioGroup aria-label="bannerType" name="bannerType" onChange={this.handleRadioChange} value={this.state.bannerType}
                            error={Boolean(touched.bannerType && errors.bannerType)}>
                              <FormControlLabel value="image"   control={<Radio  />} label="Banner Image" labelPlacement="start" />
                              <FormControlLabel value="text"  control={<Radio  />} label="Announcement Content" labelPlacement="start" />
                              
                            </RadioGroup>
                          </FormControl>
                      </div>
                      <div className="col-12" style={{display: showImage}}>
                        <div className="kt-portlet kt-portlet--height-fluid">
                          <div className="kt-portlet__body" style={{
                                'padding-bottom': '0px',
                                'padding-top': '0px',
                                'padding-right': '0px',
                                'padding-left': '0px'
                            }}>
                            
                            <img src="media/misc/01-ITC-Dashboard.png" alt="pic"/>
                        </div>
                      </div>
                      </div>
                       <div className="col-12" style={{display: showImage}}>
                        <Dropzone
                        accept="image/*"
                        onChangeStatus={this.handleChangeStatus}
                        getUploadParams={this.getUploadParams}
                        PreviewComponent={(props) => (
                                            <FileUploadPreview
                                            {...props}
                                            customStatus={this.state.statusMap[props.meta.id]}
                                            />)}
                        inputContent="Drag your image file (1507 width x 255 height)"
                        maxFiles={1}
                        multiple={false}
                        canCancel={false}
                        styles={{ dropzone: { minHeight: 200, maxHeight: 250 } }}
                       />
                      </div>  

                      <div className={"col-12"} style={{display: showText}}>
                        <div class="alert alert-light alert-elevate fade show" role="alert">
                        <div class="alert-icon"><i class="flaticon-warning kt-font-brand"></i></div>
                          <div class="alert-text" style={{'font-size':'20px', 'font-weight': 'bold'}}>
                            Welcome to My Patient Exchange
                          </div>
                        </div>
                      </div>

                      <div className={"col-12"} style={{display: showText}}>
                        <TextField
                          margin="normal"
                          label="Message"
                          className="kt-width-full"
                          id="bannerMessage"
                          name="bannerMessage"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.bannerMessage}
                          helperText={touched.bannerMessage && errors.bannerMessage}
                          error={Boolean(touched.bannerMessage && errors.bannerMessage)}
                        />
                      </div>      

                      <div className="col-12">
                        <TextField  style={{'width':'100%'}} name="publishTo" onBlur={handleBlur}
                        id="publishTo" onChange={handleChange} label="Publish To" value={values.publishTo}  select>
                          {this.state.user !== null && this.state.user!==undefined && this.state.user.length>0 && this.state.user[0].roleKey==="ROL00001" &&
                           <MenuItem key="allaccounts" value="allaccounts">All accounts</MenuItem>
                          }
                           <MenuItem key="subaccounts" value="subaccounts">Connected accounts</MenuItem>
                           <MenuItem key="private" value="private">My account</MenuItem>
                      
                        
                    </TextField>
                      </div>      

                      <div className={"col-12"}>
                        <TextField
                          margin="normal"
                          label="Display Time (in seconds)"
                          className="kt-width-full"
                          id="displayTime"
                          type="number"
                          name="displayTime"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.displayTime}
                          helperText={touched.displayTime && errors.displayTime}
                          error={Boolean(touched.displayTime && errors.displayTime)}
                        />
                      </div>    

                      <div className={"col-12"}>
                        <TextField
                          margin="normal"
                          label="Display Order (in number)"
                          className="kt-width-full"
                          id="displayOrder"
                          disabled={true}
                          type="number"
                          name="displayOrder"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={this.state.displayOrder}
                          helperText={touched.displayOrder && errors.displayOrder}
                          error={Boolean(touched.displayOrder && errors.displayOrder)}
                        />
                      </div> 

                      <div className="col-12">
                        
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container justify="space-around">
                        <KeyboardDatePicker
                              variant="inline"
                              format="MM/dd/yyyy"
                              margin="normal"
                              id="publishDate"
                              name="publishDate"
                              label="Publish Date"
                              value={this.state.publishDate}
                              helperText={touched.publishDate && errors.publishDate}
                              error={Boolean(touched.publishDate && errors.publishDate)}
                              onChange={value => {
                                this.setState({publishDate:value})
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                        </Grid>
                        </MuiPickersUtilsProvider>
                      </div>

                      <div className="col-12">
                        
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container justify="space-around">
                        <KeyboardDatePicker
                              variant="inline"
                              format="MM/dd/yyyy"
                              margin="normal"
                              id="expiryDate"
                              name="expiryDate"
                              label="Expiry Date"
                              value={this.state.expiryDate}
                              helperText={touched.expiryDate && errors.expiryDate}
                              error={Boolean(touched.expiryDate && errors.expiryDate)}
                              onChange={value => {
                                this.setState({expiryDate:value})
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                        </Grid>
                        </MuiPickersUtilsProvider>
                      </div>

                      

                     

                      

                     

                      

                    

                      

                      

                     
                      
		   			  </div>
              <div className="row">
                <div className="col-6">
                </div>
              </div>
             
              <div className="row">
                <div className="col-lg-12">
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                
                
                  </div>  
              </div>
				   
			    </div>
		    </div>
		    </CodeExample>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Update Banner
                        </button>
                      </div>
       </form>
            )}
            </Formik>

       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(EditBanner));

